// Table headers configuration for alerts data table
export const getTableHeaders = (languageParseFunction) => {
  const headers = [
    {
      title: languageParseFunction("idHeader"),
      value: "identifier",
      align: "center",
      sortable: true,
      width: "60px",
      tooltip: languageParseFunction("idDescription"),
    },
    {
      title: languageParseFunction("senderHeader"),
      value: "sender",
      align: "center",
      sortable: true,
      width: "80px",
      tooltip: languageParseFunction("senderDescription"),
    },
    {
      title: languageParseFunction("receivedHeader"),
      value: "sent",
      align: "center",
      sortable: true,
      width: "120px",
      tooltip: languageParseFunction("receivedDescription"),
    },
    {
      title: languageParseFunction("typeHeader"),
      value: "msgType",
      align: "center",
      sortable: true,
      width: "70px",
      tooltip: languageParseFunction("typeDescription"),
    },
    {
      title: languageParseFunction("statusHeader"),
      value: "status",
      align: "center",
      sortable: true,
      width: "70px",
      tooltip: languageParseFunction("statusDescription"),
    },
    {
      title: languageParseFunction("headlineHeader"),
      value: "headline",
      align: "start",
      sortable: true,
      width: "140px",
      tooltip: languageParseFunction("headlineDescription"),
    },
    {
      title: languageParseFunction("messageSizeHeader"),
      value: "messageSize",
      align: "center",
      sortable: true,
      width: "70px",
      tooltip: languageParseFunction("messageSizeDescription"),
    },
    {
      title: languageParseFunction("layerHeader"),
      value: "layers",
      align: "center",
      sortable: true,
      width: "80px",
      tooltip: languageParseFunction("layerDescription"),
    },
    {
      title: languageParseFunction("severityHeader"),
      value: "severity",
      align: "center",
      sortable: true,
      width: "70px",
      tooltip: languageParseFunction("severityDescription"),
    },
  ];

  return headers;
};
